import { Component, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CodeConversionMstDto, Sgke391aRequest, Sgke391aResponse } from 'sg-api';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';
import { Sgke390dDialogData } from '../../models/sgke390d-dialog-data';
import { UsedSgke391aService } from '../../services/used-sgke391a.service';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';

@Component({
  selector: 'app-sgke390d-dialog',
  templateUrl: './sgke390d-dialog.component.html',
  styleUrl: './sgke390d-dialog.component.scss'
})
export class Sgke390dDialogComponent implements OnInit, OnDestroy {
  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();

  /** 初期化APIの返り値 */
  initResponse: Sgke391aResponse = null;

  /** コード変換マスタマップ */
  codeMap: Map<string, CodeConversionMstDto[]> = null;

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /**
   * コンストラクタ
   * @param dialogData 画面間パラメータ
   * @param initService 初期表示APIサービス
   * @param codeConvert コード変換マスター取得サービス
   * @param {ResponseMsgUtils} responseMsgUtils メッセージ表示サービス
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: Sgke390dDialogData,
    public initService: UsedSgke391aService,
    private codeConvert: CodeConversionMstService,
    private responseMsgUtils: ResponseMsgUtils,
  ) {
  }

  ngOnInit(): void {
    // コード変換マスタ取得
    const dispItemIdList = [
      'C001941',
      'S301451',
    ];
    //コード変換マスタ共通コンポーネント呼び出し
    this.codeConvert.getCodeConversionMst(dispItemIdList)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(codeMap => {
        // ローカルに保存
        this.codeMap = codeMap;
      });
    this.init();
  }

  ngOnDestroy() {
    //購読を停止する処理
    this.onDestroy$.next();
  }


  /**
   * 初期表示API呼び出し
   */
  private init() {
    // Formの内容をリクエストに設定
    let request: Sgke391aRequest = {
      requestCommon: null,
      samplingCndt: {
        suppntSpno: this.dialogData.suppntSpno,
        supplystopresumptionRrkno: this.dialogData.supplystopresumptionRrkno,
      }
    };

    //SGKE391A_供給先関連情報画面初期表示API呼び出し
    this.initService.doSgke391a(request)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        response => {
          if (response?.workEnvInfo) {
            // レスポンスを設定
            this.initResponse = response;
          }
          // メッセージを表示
          this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
        }, error => {
        });
  }

}

